import AuthorizeStore from './components/common/authorize-store.vue';
import SyncBrands from './components/common/sync-brands.vue';
import SyncCategories from './components/common/sync-categories.vue';
import ImportProducts from './components/common/import-products.vue';
import ImportOrders from './components/common/import-orders.vue';
import SelectShopifyLocation from './components/shopify/select-location.vue';

import CreateShopifyApp from './components/shopify/create-app.vue';

import NoonStoreDetails from './components/noon/store-details.vue';
import NoonSFTP from './components/noon/configure-sftp-connection.vue';
import NoonImportProducts from './components/noon/import-products.vue';

import TrendyolStoreDetails from './components/trendyol/store-details.vue';

import CreateWhatsappCatalog from './components/whatsapp/create-catalog';
import LinkWhatsappCatalog from './components/whatsapp/link-catalog';
import PaymentMethod from './components/whatsapp/payment-method';
import WhatsAppProfile from './components/whatsapp/whatsapp-profile';
import ConnectWhatsApp from './components/whatsapp/link-whatsapp.vue';
import WhatsAppAddProducts from './components/whatsapp/add-products';
import WhatsAppChooseUsage from './components/whatsapp/choose-usage';
import AssignAccessPartner from './components/whatsapp/assign-access-partner.vue';
import ConnectCatalog from './components/whatsapp/connect-catalog.vue';
import SetupMyFatoorah from './components/whatsapp/setup-my-fatoorah.vue';
import InstallSallaApp from './components/salla/install-app.vue';
import OdooStoreDetails from './components/odoo/store-details.vue';
import OdooStoreConfig from './components/odoo/store-config.vue';
import ConnectInstagram from './components/instagram/connect-instagram.vue';
import ConnectMessenger from './components/messenger/connect-messenger.vue';
import WhatsAppQRAuthentication from './components/whatsapp-qr/whatsapp-qr-authentication.vue';
import WhatsAppQRGetQRCode from './components/whatsapp-qr/whatsapp-qr-get-qr-code.vue';
import WhatsAppQRStartSession from './components/whatsapp-qr/whatsapp_qr_start_session.vue';

export const marketplaceStepEnum = Object.freeze({
	AuthorizeStore: 'authorize_store',
	SelectShopifyLocation: 'select_shopify_location',
	SyncBrands: 'sync_brands',
	SyncCategories: 'sync_categories',
	ImportProducts: 'import_products',
	ImportOrders: 'import_orders',
	CreateShopifyApp: 'create_shopify_app',
	NoonDetails: 'noon_store_details',
	NoonSFTP: 'Configure_sftp_connection',
	NoonImportProducts: 'import_noon_products',
	TrendyolStoreDetails: 'trendyol_store_details',
	CreateCatalog: 'create_catalog',
	LinkCatalog: 'link_catalog',
	ConnectWhatsapp: 'connect_whatsapp',
	ChooseUsage: 'choose_usage',
	AssignAccessPartner: 'assign_access_partner',
	ConnectCatalog: 'connect_catalog',
	InstallSallaApp: 'install_salla_app',
	SetupMyFatoorah: 'setup_my-fatoorah',
	PaymentMethod: 'payment_method',
	WhatsAppProfile: 'whatsapp_profile',
	WhatsAppAddProducts: 'whatsapp_add_products',
	OdooStoreDetails: 'odoo_store_details',
	OdooStoreConfig: 'odoo_store_config',
	ConnectInstagram: 'connect_instagram',
	ConnectMessenger: 'connect_messenger',
	WhatsappQRAuthentication: 'whatsapp_qr_authentication',
	WhatsappQRGetQRCode: 'whatsapp_qr_get_qr_code',
	WhatsappQRStartSession: 'whatsapp_qr_start_session',
});

export const marketplaceStepStatusEnum = Object.freeze({
	Pending: 'pending',
	InProgress: 'in_progress',
	Complete: 'complete',
	Finished: 'finished',
});

export const marketplaceStepMeta = Object.freeze({
	[marketplaceStepEnum.AuthorizeStore]: {
		component: AuthorizeStore,
	},
	[marketplaceStepEnum.SelectShopifyLocation]: {
		component: SelectShopifyLocation,
	},
	[marketplaceStepEnum.SyncBrands]: {
		component: SyncBrands,
	},
	[marketplaceStepEnum.SyncCategories]: {
		component: SyncCategories,
	},
	[marketplaceStepEnum.ImportProducts]: {
		component: ImportProducts,
	},
	[marketplaceStepEnum.ImportOrders]: {
		component: ImportOrders,
	},
	[marketplaceStepEnum.CreateShopifyApp]: {
		component: CreateShopifyApp,
	},
	[marketplaceStepEnum.NoonDetails]: {
		component: NoonStoreDetails,
	},
	[marketplaceStepEnum.NoonSFTP]: {
		component: NoonSFTP,
	},
	[marketplaceStepEnum.NoonImportProducts]: {
		component: NoonImportProducts,
	},
	[marketplaceStepEnum.TrendyolStoreDetails]: {
		component: TrendyolStoreDetails,
	},
	[marketplaceStepEnum.CreateCatalog]: {
		component: CreateWhatsappCatalog,
	},
	[marketplaceStepEnum.LinkCatalog]: {
		component: LinkWhatsappCatalog,
	},
	[marketplaceStepEnum.PaymentMethod]: {
		component: PaymentMethod,
	},
	[marketplaceStepEnum.WhatsAppProfile]: {
		component: WhatsAppProfile,
	},
	[marketplaceStepEnum.WhatsAppAddProducts]: {
		component: WhatsAppAddProducts,
	},
	[marketplaceStepEnum.ConnectWhatsapp]: {
		component: ConnectWhatsApp,
	},
	[marketplaceStepEnum.ChooseUsage]: {
		component: WhatsAppChooseUsage,
	},
	[marketplaceStepEnum.AssignAccessPartner]: {
		component: AssignAccessPartner,
	},
	[marketplaceStepEnum.ConnectCatalog]: {
		component: ConnectCatalog,
	},
	[marketplaceStepEnum.SetupMyFatoorah]: {
		component: SetupMyFatoorah,
	},
	[marketplaceStepEnum.InstallSallaApp]: {
		component: InstallSallaApp,
	},
	[marketplaceStepEnum.OdooStoreDetails]: {
		component: OdooStoreDetails,
	},
	[marketplaceStepEnum.OdooStoreConfig]: {
		component: OdooStoreConfig,
	},
	[marketplaceStepEnum.ConnectInstagram]: {
		component: ConnectInstagram,
	},
	[marketplaceStepEnum.ConnectMessenger]: {
		component: ConnectMessenger,
	},
	[marketplaceStepEnum.WhatsappQRAuthentication]: {
		component: WhatsAppQRAuthentication,
	},
	[marketplaceStepEnum.WhatsappQRGetQRCode]: {
		component: WhatsAppQRGetQRCode,
	},
	[marketplaceStepEnum.WhatsappQRStartSession]: {
		component: WhatsAppQRStartSession,
	},
});
